import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import { isCurrentUserRoomMember } from '@/features/join-to-chat'

import { useStoreRooms } from '@/entities/room'


import { GUEST_ROOM_CHAT, pathNames } from '@/shared/utils/constants'
import { resolvePrepareToCallRoomId } from '@/shared/utils/router'
import { toPServedUser } from '@/shared/utils/uri'

const isGuestPrepareToCallRoute = (to: RouteLocationNormalized): boolean => {
  return to.name === pathNames.GUEST_PREPARE_TO_CALL
}

const getRoomFromStore = (roomId: string) => {
  const storeRooms = useStoreRooms()
  return storeRooms.getRoomById(roomId) ?? storeRooms.findByPServed(toPServedUser(roomId, true))
}

const tryProceedAsMember = (roomId: string, next: NavigationGuardNext): boolean => {
  const room = getRoomFromStore(roomId)
  if (isCurrentUserRoomMember(room)) {
    next()
    return true
  }
  return false
}

export const beforeEnterPrepareToCall = async (
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  const roomId = resolvePrepareToCallRoomId(to.params.roomId as string)
  const storeRooms = useStoreRooms()

  if (tryProceedAsMember(roomId, next)) {
    return
  }

  try {
    await storeRooms.awaitForRoomAdded(roomId, 500)
  } catch {
    // room not added yet — page will handle access check
  }

  if (tryProceedAsMember(roomId, next)) {
    return
  }

  if (isGuestPrepareToCallRoute(to)) {
    next({ name: GUEST_ROOM_CHAT })
    return
  }

  if (!getRoomFromStore(roomId)) {
    try {
      storeRooms.createEmptyGroupRoom(toPServedUser(roomId, true))
    } catch (error: unknown) {
      console.warn(error)
    }
  }

  next()
}
